import React, { useEffect, useState } from "react";
import History from "./History";
import MenuIcon from "@mui/icons-material/Menu";
import ChatIcon from "@mui/icons-material/Chat";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import HotelIcon from "@mui/icons-material/Hotel";
import NightShelterIcon from "@mui/icons-material/NightShelter";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import PeopleIcon from "@mui/icons-material/People";
import FeedbackIcon from "@mui/icons-material/Feedback";
import { useAuth } from "../contexts/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";

import "./Sidebar.css";

function Sidebar() {
    const { logout, userRole } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [isExpanded, setIsExpanded] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const searchParams = new URLSearchParams(location.search);
    const context = searchParams.get("context");
    const isNovoChatActive =
        location.pathname === "/chat/new" && !searchParams.has("context");

    const isActive = (path) => location.pathname === path;

    const isActiveChatOption = (key) =>
        location.pathname === "/chat/new" && context === key;

    const toggleSidebar = () => {
        setIsExpanded((prev) => !prev);
    };

    const handleNavigation = (path) => () => {
        navigate(path);
    };

    const handleSuggestionClick = (contextKey) => {
        window.location.href = `/chat/new?context=${contextKey}`;
    };


    const chatOptions = [
        {
            key: "gestao_leitos",
            label: "Gestão de Leitos",
            icon: <HotelIcon />,
        },
        {
            key: "resumo_paciente",
            label: "Resumo do Paciente",
            icon: <AssignmentIndIcon />,
        },
        {
            key: "taxa_ocupacao_leitos",
            label: "Taxa de Ocupação de Leitos",
            icon: <NightShelterIcon />,
        },
        {
            key: "duvidas_gerais",
            label: "Dúvidas Gerais",
            icon: <LiveHelpIcon />,
        },
    ];

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 600;
            setIsMobile(mobile);
            setIsExpanded(!mobile);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isMobile && isExpanded) {
            document.body.classList.add("sidebar-mobile-open");
        } else {
            document.body.classList.remove("sidebar-mobile-open");
        }
    }, [isMobile, isExpanded]);

    const renderMenu = ({ showDashboard, showUserList, showFeedbacks }) => (
        <>
            <div>
                <div className="menu-icon" title="Menu" onClick={toggleSidebar}>
                    <Tooltip title="Menu" placement="right" arrow>
                        <MenuIcon style={{ cursor: "pointer" }} />
                    </Tooltip>
                    {isExpanded && <span className="menu-label"></span>}
                </div>

                {showDashboard && (
                    <div
                        className={`menu-icon ${isActive("/dashboard") ? "active-icon" : ""}`}
                        onClick={handleNavigation("/dashboard")}
                    >
                        <Tooltip title="Dashboard" placement="right" arrow>
                            <DashboardIcon style={{ cursor: "pointer" }} />
                        </Tooltip>
                        {isExpanded && (
                            <span
                                className={`menu-label ${isActive("/dashboard") ? "active-label" : ""}`}
                            >
                                Dashboard
                            </span>
                        )}
                    </div>
                )}

                <a
                    href="/chat/new"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    <div className={`menu-icon ${isNovoChatActive ? "active-icon" : ""}`}>
                        <Tooltip title="Novo Chat" placement="right" arrow>
                            <ChatIcon
                                style={{
                                    cursor: "pointer",
                                    color: isNovoChatActive ? "#1588C9" : undefined,
                                }}
                            />
                        </Tooltip>
                        {isExpanded && (
                            <span
                                className={`menu-label ${isNovoChatActive ? "active-label" : ""
                                    }`}
                            >
                                Novo Chat
                            </span>
                        )}
                    </div>
                </a>

                {chatOptions.map((option) => {
                    const active = isActiveChatOption(option.key);
                    return (
                        <div
                            key={option.key}
                            className={`menu-icon ${active ? "active-icon" : ""}`}
                            onClick={() => handleSuggestionClick(option.key)}
                        >
                            <Tooltip title={option.label} placement="right" arrow>
                                {React.cloneElement(option.icon, {
                                    style: {
                                        cursor: "pointer",
                                        color: active ? "#1588C9" : undefined,
                                    },
                                })}
                            </Tooltip>
                            {isExpanded && (
                                <span
                                    className={`menu-label ${active ? "active-label" : ""
                                        }`}
                                >
                                    {option.label}
                                </span>
                            )}
                        </div>
                    );
                })}

                {showUserList && (
                    <div
                        className={`menu-icon ${isActive("/user/list") ? "active-icon" : ""}`}
                        onClick={handleNavigation("/user/list")}
                    >
                        <Tooltip title="Usuários" placement="right" arrow>
                            <PeopleIcon style={{ cursor: "pointer" }} />
                        </Tooltip>
                        {isExpanded && (
                            <span
                                className={`menu-label ${isActive("/user/list") ? "active-label" : ""
                                    }`}
                            >
                                Usuários
                            </span>
                        )}
                    </div>
                )}

                {showFeedbacks && (
                    <div
                        className={`menu-icon ${isActive("/feedbacks") ? "active-icon" : ""}`}
                        onClick={handleNavigation("/feedbacks")}
                    >
                        <Tooltip title="Feedbacks" placement="right" arrow>
                            <FeedbackIcon style={{ cursor: "pointer" }} />
                        </Tooltip>
                        {isExpanded && (
                            <span
                                className={`menu-label ${isActive("/feedbacks") ? "active-label" : ""
                                    }`}
                            >
                                Feedbacks
                            </span>
                        )}
                    </div>
                )}
            </div>

            {isExpanded && (
                <div className="history-container mt-3">
                    <History />
                </div>
            )}

            <div className="new-chat">
                {!isExpanded ? (
                    <div className="menu-icon" title="Sair" onClick={logout}>
                        <Tooltip title="Sair" placement="right" arrow>
                            <LogoutIcon style={{ cursor: "pointer" }} />
                        </Tooltip>
                        {isExpanded && <span className="menu-label">Sair</span>}
                    </div>
                ) : (
                    ""
                )}
            </div>
        </>
    );

    return (
        <>
            {isMobile && !isExpanded && (
                <div className="mobile-toggle" onClick={toggleSidebar}>
                    <MenuIcon style={{ cursor: "pointer", margin: "10px" }} />
                </div>
            )}

        {isMobile && isExpanded && (
            <div className="overlay" onClick={toggleSidebar}></div>
        )}

            <div
                className={`sidebar ${isExpanded ? "expanded" : ""} ${isMobile ? "mobile" : ""
                    }`}
            >
                {userRole === "ADMIN" &&
                    renderMenu({ showDashboard: true, showUserList: true, showFeedbacks: true })}
                {userRole === "MANAGER" &&
                    renderMenu({ showDashboard: true, showUserList: false, showFeedbacks: false })}
                {userRole === "USER" &&
                    renderMenu({ showDashboard: false, showUserList: false, showFeedbacks: false })}
            </div>
        </>
    );
}

export default Sidebar;
